import { NestedHome } from "@habity/types";
import { CommonEstateBid } from "@habity/types/vitec/common/commonEstateBid";
import { BidSettingEnum } from "@habity/types/vitec/common/commonEstateInternetSettings";

/**
 * Helper to get bidSetting from home
 */
const getBidSetting = (home: NestedHome): BidSettingEnum | undefined => {
  return home.provider_data?.internetSettings?.bidSetting;
};

/**
 * Get all active (non-cancelled) bids for a home
 */
export const getActiveBids = (home: NestedHome | null): CommonEstateBid[] => {
  return home?.provider_data?.bids?.filter((bid) => !bid.cancelled) || [];
};

/**
 * Get the highest bid amount for a home
 */
export const getHighestBid = (home: NestedHome | null): number => {
  const bids = getActiveBids(home);
  return bids.length === 0 ? 0 : Math.max(...bids.map((bid) => bid.amount ?? 0));
};

/**
 * Check if a home has active bidding that is visible on the site
 * Bidding is visible if bidSetting is ShowHighestBid or ShowBiddhistory
 */
export const hasBiddingActive = (home: NestedHome): boolean => {
  const bidSetting = getBidSetting(home);
  return home.is_bidding_active === true && 
         (bidSetting === 'ShowHighestBid' || bidSetting === 'ShowBiddhistory');
};

/**
 * Check if we should show the highest bid (not the full bid history)
 * Only true when bidSetting is specifically ShowHighestBid
 */
export const shouldShowHighestBid = (home: NestedHome): boolean => {
  return home.is_bidding_active === true && getBidSetting(home) === 'ShowHighestBid';
};

/**
 * Check if we should show the full bid history
 * Only true when bidSetting is specifically ShowBiddhistory
 */
export const shouldShowBidHistory = (home: NestedHome): boolean => {
  return home.is_bidding_active === true && getBidSetting(home) === 'ShowBiddhistory';
};
